export default "__VITE_ASSET__BgGT$RLM__"